export const DELETE_SESSION_FILE = "SESSION_DELETE_FILE";
export const DELETE_SESSION_FILE_SUCCESS = "SESSION_DELETE_FILE_SUCCESS";
export const DELETE_SESSION_FILE_ERROR = "SESSION_DELETE_FILE_ERROR";
export const RESET_DELETE_SESSION_FILE = "SESSION_RESET_DELETE_FILE";

export interface DeleteFile {
  type: typeof DELETE_SESSION_FILE;
  payload: { idFile: number };
}

export interface DeleteFileSuccess {
  type: typeof DELETE_SESSION_FILE_SUCCESS;
  payload: null;
}

export interface DeleteFileError {
  type: typeof DELETE_SESSION_FILE_ERROR;
  payload: string | boolean;
}

export interface ResetDeleteFile {
  type: typeof RESET_DELETE_SESSION_FILE;
  payload: null;
}

export interface State {
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions =
  | DeleteFile
  | DeleteFileSuccess
  | DeleteFileError
  | ResetDeleteFile;
